module.exports = __webpack_public_path__ + "static/img/product02-5.18b8042a.png";